import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

export type InvoicePrevidasStatus =
  | 'agendada'
  | 'autorizada'
  | 'processando_cancelamento'
  | 'cancelada'
  | 'negada_cancelamento'
  | 'erro'
  | 'NONE';

export enum EDoctorInvoiceStatus {
  SCHEDULED = 'SCHEDULED',
  AUTHORIZED = 'AUTHORIZED',
  PROCESSING_CANCELLATION = 'PROCESSING_CANCELLATION',
  CANCELED = 'CANCELED',
  CANCELLATION_DENIED = 'CANCELLATION_DENIED',
  ERROR = 'ERROR',
  SYNCHRONIZED = 'SYNCHRONIZED',
}

export type InvoiceDoctorRowStatus =
  | 'ELIGIBLE'
  | 'RETRY'
  | 'PROCESSING'
  | 'DONE'
  | 'BLOCKED';

export interface InvoiceDoctorRow {
  invoiceDoctorId: number | null;
  indicationId: number;
  indicationStatus: string;
  paymentId: string;
  paidAt: string;
  consultationDate: string | null;
  patient: { id: number; name: string };
  doctor: { id: number | null; name: string | null };
  totalAmount: number;
  transactionId: number;
  scheduleId: number;
  doctorTransferAmount: number;
  hasDocument: boolean;
  invoice: {
    status: EDoctorInvoiceStatus;
    nfeId?: string;
    pdfUrl?: string;
    xmlUrl?: string;
    lastFailureReason?: string;
  };
  row: {
    status: InvoiceDoctorRowStatus;
    blockedReason?: string;
    actionLabel?: string;
  };
}

export interface ListInvoiceDoctorParams {
  startDate: string;
  endDate: string;
  doctorIds?: number[];
}

export interface InvoiceDoctorOption {
  id: number;
  name: string;
}

export interface DispatchInvoiceDoctorResult {
  invoiceIndicationId: number;
  status: 'success' | 'failed';
  reason?: string;
  dispatchId: string;
}

export interface EmitByIndicationResult {
  indicationId: number;
  status: 'success' | 'skipped' | 'failed';
  reason?: string;
}
export type ScheduleDoctorNfseBody = {
  indicationId: number;
  indicationStatus: string;
  transactionId: number;
  scheduleId: number;
  transactionDoctorTransferValue: number;
}

export type ScheduleDoctorNfseResponse = {
  code: number;
  success: false;
  message: string;
  nfe?: {
    invoiceId: string;
    indicationId: number;
    status: string;
  }
};

@Injectable({ providedIn: 'root' })
export class AdministrativeInvoiceDoctorService {
  private readonly url = `${environment.api_v2}/v2/administrative/invoice-indication`;
  private readonly emitNfseEndpoint = `${environment.api_v2}/v2/administrative/financial/invoice/schedule/nfse`;

  constructor(private readonly http: HttpClient) {}

  list(params: ListInvoiceDoctorParams): Observable<InvoiceDoctorRow[]> {
    let httpParams = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate);
    if (params.doctorIds && params.doctorIds.length > 0) {
      for (const id of params.doctorIds) {
        httpParams = httpParams.append('doctorIds', String(id));
      }
    }
    return this.http.get<InvoiceDoctorRow[]>(`${this.url}/rows`, { params: httpParams });
  }

  emit(body: ScheduleDoctorNfseBody): Observable<ScheduleDoctorNfseResponse> {
    return this.http.post<ScheduleDoctorNfseResponse>(
      this.emitNfseEndpoint,
      body
    );
  }

  listDoctors(): Observable<InvoiceDoctorOption[]> {
    return this.http.get<InvoiceDoctorOption[]>(`${this.url}/doctors`);
  }
}
